import React from 'react';
export const useHashReducer = () => {
    const hashReducer = (state, hash) => hash;
    const hashInitializer = (initial) => initial;
    const [dataGridHash, dispatchDataGridHash] = React.useReducer(hashReducer, '', hashInitializer);
    return [dataGridHash, dispatchDataGridHash];
};
